import React from 'react'

import { useTranslation } from 'language/translator'

import StepAtom from 'components_new/atoms/Stepper/Step'
import StepLabel from 'components_new/atoms/Stepper/StepLabel'
import Stepper from 'components_new/atoms/Stepper'

import MetricsTableHero from 'components_new/organisms/MetricsTableHero'

import { type Step, getStepMeta } from './lib'
import { ISelectMetric } from 'types/GlobalMetric'

interface Props {
  tab: 'metrics' | 'other'
  metric: ISelectMetric | null
  search: string | null
  setSearch: (v: string | null) => void
  category: string | null
  setCategory: (v: string | null) => void
  subcategory: string | null
  setSubcategory: (v: string | null) => void
  activeStep: number
  steps: Step[]
}

const Hero = (props: Props) => {
  const {
    tab,
    metric,
    search,
    setSearch,
    category,
    setCategory,
    subcategory,
    setSubcategory,
    activeStep,
    steps
  } = props

  const { t } = useTranslation()

  if (tab !== 'metrics') return null

  if (metric) {
    if (steps.length <= 1) return null

    return (
      <Stepper activeStep={activeStep}>
        {steps.map((step, i) => (
          <StepAtom key={i}>
            <StepLabel>{getStepMeta(step, t).title}</StepLabel>
          </StepAtom>
        ))}
      </Stepper>
    )
  }

  return (
    <MetricsTableHero
      search={search}
      setSearch={setSearch}
      category={category}
      setCategory={(value) => {
        setCategory(value)
        setSubcategory(null)
      }}
      subcategory={subcategory}
      setSubcategory={setSubcategory}
    />
  )
}

export default Hero
